const apiUrl = 'https://api.trustoo.io/api/v1/reviews/get_product_reviews?shop_id=1592000625&limit=3&page=2&scene=1&is_show_all=1&sort_by=rating-descending&lang=de&t=1740428401';

const fetchReviewsData = url => {
  const reviewsScore = document.querySelector('.hp-hero__reviews-score');
  const reviewsAmount = document.querySelector('.hp-hero__reviews-amount');

  if (reviewsScore && reviewsAmount && url) {
    fetch(url)
    .then(response => response.json())
    .then(data => {
      reviewsScore.textContent = data?.data?.total_rating?.rating;
      reviewsAmount.textContent = data?.data?.total_rating?.total_reviews;
    })
  }
}

fetchReviewsData(apiUrl);
